import React from 'react';

export const DashboardPopUpContext = React.createContext({
  isPopUpVisible: false,
  showPopUp: () => {},
  hidePopUp: () => {}
});